exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table-row:hover{color:#ffc000;background:hsla(0,0%,100%,.05);cursor:pointer}.table-row th:hover{color:#ffc000}.search-table-btn{min-width:80px;padding:0;margin:2px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/BasicSearchRow/styles.scss
// module id = 742
// module chunks = 0